var map = {
	"./add-attachment.svg": "4231",
	"./add-image.svg": "4f84",
	"./add-link.svg": "809b",
	"./add-product.svg": "aa15",
	"./align-center.svg": "86d7",
	"./align-left.svg": "d4aa",
	"./align-right.svg": "7526",
	"./angle-up.svg": "dca6",
	"./animation.svg": "3c211",
	"./appointment-cancel.svg": "1cea",
	"./appointment-link.svg": "bbd0",
	"./arc.svg": "970e",
	"./arrow-down-m.svg": "74bd",
	"./arrow-down.svg": "c874",
	"./arrow-left.svg": "ac3b",
	"./arrow-right-little.svg": "e9fa",
	"./arrow-up.svg": "a3f8",
	"./background.svg": "1473",
	"./birthday.svg": "1e3b",
	"./blank-checkobox.svg": "5720",
	"./bold.svg": "ff26",
	"./calendar.svg": "b8bd",
	"./calendar2.svg": "cdaa",
	"./cancel.svg": "b463",
	"./caret-down-black.svg": "3dde",
	"./caret-down-grey.svg": "123b",
	"./caret-down-white.svg": "319c",
	"./caret-down.svg": "3f24",
	"./caret-up-black.svg": "2c34",
	"./caret-up-white.svg": "0071",
	"./caret-up.svg": "2d60",
	"./caret.svg": "1f4a",
	"./carousel-left.svg": "572c",
	"./carousel-right.svg": "c3f3",
	"./chain-link.svg": "398a",
	"./chat.svg": "9b69",
	"./check-black.svg": "4793",
	"./check-bold-grey.svg": "9052",
	"./check-bold.svg": "e7b0",
	"./check-circle.svg": "cfcb",
	"./check-dark.svg": "92f7",
	"./check-grey.svg": "7d3a",
	"./check-light.svg": "5d82",
	"./check-white.svg": "5131",
	"./check.svg": "7bae",
	"./checked-black.svg": "3d50",
	"./checked-circle-v2.svg": "00ba",
	"./checked.svg": "0aae",
	"./chevron-down-black.svg": "60d8",
	"./chevron-down-grey.svg": "3407",
	"./chevron-down.svg": "1755",
	"./chevron-up-grey.svg": "4c3a",
	"./circle.svg": "b289",
	"./clicked-link.svg": "106a",
	"./clipboard.svg": "4247",
	"./close-circle-black.svg": "0e8d",
	"./close-circle.svg": "1cfc",
	"./close-small.svg": "a970",
	"./close-x.svg": "17b8",
	"./collage.svg": "c116",
	"./colored-check.svg": "dd6c",
	"./create-link.svg": "8256",
	"./crop.svg": "2269",
	"./delete.svg": "0d45",
	"./desktop.svg": "83b8",
	"./disabled-checkbox.svg": "1aa4",
	"./download-new.svg": "b512",
	"./download-report.svg": "187d",
	"./download.svg": "f28e",
	"./edit-small.svg": "ca9d",
	"./editor_user.svg": "a297",
	"./ellipsis-h.svg": "ecfd",
	"./embed-link.svg": "9264",
	"./emoji.svg": "93255",
	"./empty-chart.svg": "3e39",
	"./enter_input.svg": "e3cf",
	"./exclamation-circle-error.svg": "763b",
	"./exclamation-circle.svg": "8128",
	"./eye.svg": "7364",
	"./file-gif.svg": "bb86",
	"./file-jpg.svg": "c256",
	"./file-pdf.svg": "d890",
	"./file.svg": "a147",
	"./filter.svg": "2376",
	"./folderMono.svg": "3319",
	"./font.svg": "b8a2",
	"./hamburger-menu.svg": "b602",
	"./heart-select-animation.svg": "0fae",
	"./heart-selected.svg": "3364",
	"./heart.svg": "7d16",
	"./hexagon.svg": "1ea9",
	"./icon-plus.svg": "a3b7",
	"./icon-product.svg": "fdaf",
	"./image-upload.svg": "5d57",
	"./image-widget-empty.svg": "7d2e",
	"./image.svg": "931c",
	"./images-row-large.svg": "e0d6",
	"./images-row.svg": "37a4",
	"./information-error.svg": "e986",
	"./italic.svg": "9944",
	"./kebab-horizontal.svg": "2535",
	"./left-arrow.svg": "6d4b",
	"./mail.svg": "3ae9",
	"./mainav_appoinment.svg": "8c2c",
	"./mic.svg": "6366",
	"./minus.svg": "3e24",
	"./mobile-arrow-left.svg": "7f65",
	"./mobile-arrow-right.svg": "1d91",
	"./mobile-back.svg": "7e3d",
	"./mobile.svg": "0df4",
	"./move-to-back.svg": "24d0",
	"./move-to-front.svg": "0226",
	"./mplus-client.svg": "e5c5",
	"./mute.svg": "11df",
	"./no-chat.svg": "067a",
	"./open-chat-white.svg": "491f",
	"./open-chat.svg": "ca50",
	"./orange-arrow-down.svg": "0eea",
	"./orange-arrow-up.svg": "247d",
	"./oval.svg": "55a1",
	"./pass-off.svg": "9005",
	"./pass-on.svg": "dc5f",
	"./paste-new.svg": "027c",
	"./paste.svg": "acb9",
	"./pencil-circle.svg": "cf9e",
	"./pencil.svg": "e51f",
	"./pick-date.svg": "c0a3",
	"./play-button.svg": "7d05",
	"./plus-m.svg": "adbe",
	"./plus-original.svg": "7c29",
	"./plus.svg": "eb38",
	"./preview-icon.svg": "6c61",
	"./preview.svg": "774c",
	"./product-arrow-left.svg": "3f7b9",
	"./product-arrow-right.svg": "3728",
	"./product-row-large.svg": "46a3",
	"./product-row.svg": "ef35",
	"./product-widget-empty.svg": "a731",
	"./profile.svg": "95dc",
	"./rectangle.svg": "3bba",
	"./redo.svg": "63dc",
	"./refresh_input.svg": "cc32",
	"./remove-attachment.svg": "ffb0",
	"./remove-background.svg": "194d",
	"./right-arrow-cell.svg": "8928",
	"./right-arrow.svg": "c686",
	"./save-pdf.svg": "a077",
	"./schedule-send.svg": "05a4",
	"./schedule.svg": "6b6f",
	"./search-base.svg": "ae1c",
	"./search.svg": "d103",
	"./search_nomatches.svg": "e1c5",
	"./search_notfound.svg": "9f27",
	"./selected.svg": "0443",
	"./selected_blank.svg": "7dc3",
	"./send-email-inverse.svg": "61cc",
	"./send-email.svg": "b036",
	"./send-gmail.svg": "26a0",
	"./send-now.svg": "10e1",
	"./send-outlook.svg": "53c5",
	"./send-test.svg": "d934",
	"./send.svg": "5b6e",
	"./shape-circle-small.svg": "9849",
	"./shape-circle.svg": "e95e",
	"./shape-closed-arc-small.svg": "7745",
	"./shape-closed-arc.svg": "70491",
	"./shape-heart-small.svg": "5863",
	"./shape-heart.svg": "75a8",
	"./shape-hexagon-small.svg": "66fa",
	"./shape-hexagon.svg": "ddae",
	"./shape-oval-small.svg": "6006",
	"./shape-oval.svg": "81cd",
	"./shape-square-small.svg": "c4e1",
	"./shape-square.svg": "31c2",
	"./shape-star-small.svg": "21cf",
	"./shape-star.svg": "c837",
	"./share-screen.svg": "00b9",
	"./share.svg": "bd5b",
	"./shareV2.svg": "022f",
	"./sidebar_activity.svg": "3f1d",
	"./sidebar_album.svg": "aa8e",
	"./sidebar_appointments.svg": "a37f",
	"./sidebar_clients.svg": "4001",
	"./sidebar_explore.svg": "61f9",
	"./sidebar_inventory.svg": "ff66",
	"./sidebar_outreach.svg": "6270",
	"./sidebar_report.svg": "9dbe",
	"./sign-out.svg": "8e2f",
	"./star-gray.svg": "b794",
	"./stop-sharing.svg": "5618",
	"./stop-video.svg": "06ed",
	"./submenu-arrow-right-small.svg": "988d",
	"./submenu-arrow-right.svg": "473a",
	"./tablet.svg": "a9e0",
	"./text-box-large.svg": "acff",
	"./text-box.svg": "3021",
	"./text-size.svg": "4157",
	"./text-widget-empty.svg": "eab8",
	"./toggle-off.svg": "277d",
	"./toggle-on.svg": "faf7",
	"./unchecked-black.svg": "c59a",
	"./unchecked.svg": "0cab",
	"./underline.svg": "f893",
	"./undo.svg": "34b1",
	"./upload.svg": "5a96",
	"./uploadV2black.svg": "2d83",
	"./uploadV2white.svg": "f3e6",
	"./video-camera-gray.svg": "727c",
	"./video-camera.svg": "409e",
	"./wechatQR-link.svg": "4c8a",
	"./white-plus.svg": "cd46",
	"./widget-close.svg": "9666",
	"./x-24.svg": "109c",
	"./x-circle-black.svg": "e9ee",
	"./x-circle-grey.svg": "218a",
	"./x-circle.svg": "2940",
	"./xcross-bold.svg": "6987"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";